import React from "react";
import { ClassFilterType } from "@common/types/class";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
    FilterMultiselectValue,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

const HAS_CLASS = "has_class";
const NO_CLASS = "no_class";

const options: FilterMultiselectOption[] = [
    {
        value: HAS_CLASS,
        label: "Has class",
        searchableLabel: "has class",
    },
    {
        value: NO_CLASS,
        label: "Does not have a class",
        searchableLabel: "does not have a class",
    },
];

function classFilterTypeFromSelection(
    selected: FilterMultiselectValue[],
): ClassFilterType | undefined {
    const isHasClassSelected = selected.includes(HAS_CLASS);
    const isNoClassSelected = selected.includes(NO_CLASS);
    if (isHasClassSelected === isNoClassSelected) {
        return undefined;
    }
    return isHasClassSelected
        ? ClassFilterType.HAS_CLASSES
        : ClassFilterType.NO_CLASSES;
}

/**
 * Simplified class filter for transaction task templates.
 * Toggles "Has class" / "Does not have a class" without the class pick list.
 */
export const TemplateClassFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const value: FilterMultiselectValue[] = [
        ...(filters.classFilterType === ClassFilterType.HAS_CLASSES
            ? [HAS_CLASS]
            : []),
        ...(filters.classFilterType === ClassFilterType.NO_CLASSES
            ? [NO_CLASS]
            : []),
    ];

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                searchable={false}
                options={options}
                value={value}
                onChange={(selected) =>
                    onChange({
                        classFilterType: classFilterTypeFromSelection(selected),
                        classes: undefined,
                    })
                }
                name="templateClass"
                onBlur={noop}
            />
        </div>
    );
};
